import { useQuery } from '@tanstack/react-query';
import { ChevronLeft, Info, Link as LinkIcon, UserRoundPlus } from 'lucide-react';
import { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import apiClient from '../../../api/client';
import Branches from '../../../components/branch';
import CampaignCard from '../../../components/campaign/card';
import ImageWithFallback from '../../../components/ImageWithFallback';
import MembershipCard from '../../../components/membership/card';
import HeaderList from '../../../components/reward/header-list';
import { Button } from '../../../components/ui/button';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '../../../components/ui/carousel';
import { Dialog, DialogContent, DialogHeader } from '../../../components/ui/dialog';
import { Drawer, DrawerContent } from '../../../components/ui/drawer';
import { Toaster } from '../../../components/ui/toaster';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../../components/ui/tooltips';
import { campaignData } from '../../../dummy/campaignData';
import { myRewards } from '../../../dummy/my-rewards';
import RewardSection from './RewardSection';

const getBrandDetails = (brandId?: string) => {
  const rewards = [
    ...myRewards.joinedRewards,
    ...myRewards.participatingBrands,
  ];
  return rewards.find((reward) => reward.id === brandId);
};

type GetEntityDetailResponse = {
  success: boolean;
  message: string;
  data: {
    entity_name: string | null;
    entity_logo_image: string | null;
    [key: string]: any;
  };
  statusCode: number;
};

export default function RewardTierDetails() {
  const params = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);

  const { data: entityDetail } = useQuery<GetEntityDetailResponse>({
    queryKey: ["getRewardBrands"],
    queryFn: async () => {
      const resp = await apiClient.get(`/reward/brands/${params.id}`);
      return resp.data;
    },
  });

  console.log('Entity Detail:', entityDetail);

  const brand = {
    id: params.id,
    name: entityDetail?.data.entity_name,
    logo: entityDetail?.data.entity_logo_image,
    rewardPoints: 100,
  }

  const handleInviteFriend = () => {
    console.log('Invite a friend clicked');
    setOpenDrawer(true);
  }

  const actions: {
    title: string;
    onClick: () => void;
    icon?: React.FC<{ className?: string }>;
    image?: string;
  }[] = [
    {
      title: 'Copy link',
      onClick: () => {
        const link = 'https://example.com/invite?referralCode=12345';
        navigator.clipboard.writeText(link);
        toast.success('Link copied to clipboard!');
        setOpenDrawer(false);
      },
      icon: LinkIcon
    },
    // {
    //   title: 'WhatsApp',
    //   onClick: () => {
    //     console.log('Share via WhatsApp clicked');
    //     setOpenDrawer(false);
    //   },
    //   image: '/assets/images/whatsapp.png',
    // },
    // {
    //   title: 'Messenger',
    //   onClick: () => {
    //     console.log('Share via Messenger clicked');
    //     setOpenDrawer(false);
    //   },
    //   image: '/assets/images/messenger.png',
    // },
    // {
    //   title: 'Telegram',
    //   onClick: () => {
    //     console.log('Share via Messenger clicked');
    //     setOpenDrawer(false);
    //   },
    //   image: '/assets/images/telegram.png',
    // },
    // {
    //   title: 'Instagram Direct',
    //   onClick: () => {
    //     console.log('Share via Messenger clicked');
    //     setOpenDrawer(false);
    //   },
    //   image: '/assets/images/instagram.png',
    // },
    // {
    //   title: 'SMS',
    //   onClick: () => {
    //     console.log('Share via Messenger clicked');
    //     setOpenDrawer(false);
    //   },
    //   image: '/assets/images/sms.png',
    // },
  ]

  return (
    <>
      <section className='flex flex-col gap-y-8'>
        <div className={'flex gap-2 px-6 mt-4 items-end justify-between'}>
          <div className='flex items-start gap-2'>
            <button onClick={() => navigate(-1)}>
              <ChevronLeft />
            </button>
            <div className='size-16 md:size-20 ml-2'>
              <ImageWithFallback 
                src={brand.logo || ''}
                alt={brand.name || 'brand logo'}
              />
            </div>
          </div>

          <Button 
            variant={'outline'} 
            onClick={() => setOpenDialog(true)}
            className='rounded-full px-4 py-2 text-primary border-primary hover:bg-primary hover:text-white'
          >
            <UserRoundPlus />
            Referral Program
          </Button>

        </div>
        <Link
          to={`/my-rewards-hub/${brand.id}/tiers`}
          className='w-full md:max-w-[60%] px-2 xl:max-w-[40%]'
        >
          <MembershipCard
            isBrand
            brandName={brand.name || ''}
            rewardName={'Level 1'}
            image={brand.logo || ''}
            // rewardPoints={brand.rewardPoints}
            description={`Earn points when you shop at ${brand.name?.toLowerCase()}`}
          />
        </Link>
  
        <RewardSection
          id={brand.id || ''}
          merchantName={brand.name || ''}
        />

        <div className='mx-auto flex w-full max-w-[calc(100%-2rem)] flex-col gap-y-4'>
          <HeaderList
            title='Active Campaigns'
            href={`/my-rewards-hub/${brand.id}/active-campaigns?type=active`}
            description={undefined}
          />
          <Carousel
            opts={{
              align: 'start',
            }}
            className='z-20 max-w-full bg-inherit'
          >
            <CarouselContent className={'items-stretch pl-2'}>
              {campaignData?.map((campaign, index) => (
                <CarouselItem
                  key={index}
                  className={`basis-[45%] scroll-pl-6 shadow-none drop-shadow-none md:basis-[65%] lg:basis-1/5`}
                >
                  {/* <div className="h-full"> */}
                  <Link to={`active-campaigns/${campaign.campaignId}`}>
                    <CampaignCard
                      campaign={campaign}
                      className={''}
                    />
                  </Link>
                  {/* </div> */}
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </div>
        <div className='mx-auto flex w-full max-w-[calc(100%-2rem)] flex-col gap-y-4 pb-4'>
          <HeaderList
            title='Locations'
            href={'/all-locations'}
            description={`Find ${brand.name}'s stores near you that accept AyeFace`}
          />
          <Branches className={'px-2'} />
        </div>
      </section>

      <Drawer open={openDrawer} onOpenChange={setOpenDrawer}>
        <DrawerContent>
          <div className="mx-auto w-full flex flex-row px-4 pb-8 overflow-auto hide-scrollbar">
            {actions.map((action, index) => {
              return (
                <div
                  key={index}
                  className="flex flex-col items-center gap-3 py-2 px-3 cursor-pointer hover:bg-slate-100 rounded-md"
                  onClick={action.onClick}
                >
                    <div className='size-12 bg-white rounded-full p-2 shadow-lg shadow-black/30 flex items-center justify-center'>
                      {action.image ? (
                        <img src={action.image} alt={action.title} className="w-12 h-12 min-w-12 rounded-full" />
                      ) : action.icon && (
                        <action.icon className="text-foreground/80 size-6" />
                      )}
                    </div>

                  <p className="text-xs font-light text-center">{action.title}</p>
                </div>
              );
            })}
          </div>
        </DrawerContent>
      </Drawer>

      <Dialog open={openDialog} onOpenChange={setOpenDialog}>
        <DialogContent className="max-w-[24rem] rounded-3xl">
          <DialogHeader>
            <div className="mx-6 border-2 mt-6 flex flex-col gap-1 py-4 rounded-2xl shadow-lg shadow-black/20">
              <div className='flex mx-auto gap-2 items-center'>
                My successful referrals 
                <TooltipProvider>
                  <Tooltip delayDuration={0}>
                    <TooltipTrigger asChild>
                      <Info className="h-4 w-4 text-gray-500 cursor-help" />
                    </TooltipTrigger>
                    <TooltipContent side="top" className="w-56 bg-[#F3F3F3]">
                      <p className='text-xs font-extralight text-[#101B2C]'>
                        Face ID update is not available at the moment. If you need assistance, please contact us
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              </div>
              <p className='text-primary font-bold text-center'>2</p>
            </div>
          </DialogHeader>

          <img 
            src="/assets/images/gift.png" 
            alt={brand.name || 'gift'} 
            className='size-28 mx-auto' 
          />

          <h3 className='text-md font-light text-center px-6'>
            Refer a friend to spend at {brand.name} and earn [amount] [reward type] when they make a purchase
          </h3>

          <Button className='mx-8' onClick={handleInviteFriend}>Invite a friend</Button>

          <p className='text-xs text-center px-4 italic text-foreground/80'>
            This offer is only applicable to friends who have never made a payment with AyeFace at any of this brand's outlets
          </p>
        </DialogContent>
      </Dialog>

      <Toaster />
    </>
  );
}
